/**
 * A config containing properties for the info status card
 */
var InfoStatusCardConfig = /** @class */ (function () {
    function InfoStatusCardConfig() {
    }
    return InfoStatusCardConfig;
}());
export { InfoStatusCardConfig };
//# sourceMappingURL=info-status-card-config.js.map